export let nextActionResults = [
  { key: 'RE_SUBMIT', value: '重新提交' },
  { key: 'RE_PROVIDE', value: '重新提供样品' },
  { key: 'REDO_REPORT_GENERATE', value: '重新出具报告' },
  { key: 'STOP', value: '中止' },
  { key: 'ABANDON', value: '废弃' },
  { key: 'RE_SET', value: '恢复' },
  { key: 'BILL_HANDLE', value: '确认已处置' },
  { key: 'BILL_DELIVERY', value: '确认已完成交付' },
  { key: 'YAN_QI_JIAO_FU', value: '延期交付' },
  { key: 'BILL_CLOSE', value: '关闭' },
]

// 颜色
export const colors = [{
      value: '红色',
      label: '红色'
    },
    {
      value: '白色',
      label: '白色'
    },
    {
      value: '无色',
      label: '无色'
    },
    {
      value: '无色透明',
      label: '无色透明'
    },
    {
      value: '银色',
      label: '银色'
    },
    {
      value: '黄色',
      label: '黄色'
    },
    {
      value: '乳白色',
      label: '乳白色'
    },
    {
      value: '淡黄色',
      label: '淡黄色'
    },
    {
      value: '浅黄色',
      label: '浅黄色'
    },
    {
      value: '黑色',
      label: '黑色'
    },
    {
      value: '灰色',
      label: '灰色'
    },
    {
      value: '蓝色',
      label: '蓝色'
    },
    {
      value: '绿色',
      label: '绿色'
    },
    {
      value: '褐色',
      label: '褐色'
    },
    {
      value: '棕色',
      label: '棕色'
    },
    {
      value: '粉色',
      label: '粉色'
    },
    {
      value: '红褐色',
      label: '红褐色'
    },
    {
      value: '砖红色',
      label: '砖红色'
    },
    {
      value: '浅粉色',
      label: '浅粉色'
    },
    {
      value: '类白色',
      label: '类白色'
    },
    {
      value: '其他',
      label: '其他'
    }
  ]
  // 形态
export const shapes = [{
    value: '固体',
    label: '固体'
  },
  {
    value: '半固体',
    label: '半固体'
  },
  {
    value: '液体',
    label: '液体'
  },
  {
    value: '气体',
    label: '气体'
  },
  {
    value: '粉末',
    label: '粉末'
  },
  {
    value: '颗粒',
    label: '颗粒'
  },
  {
    value: '结晶性粉末',
    label: '结晶性粉末'
  },
  {
    value: '凝胶',
    label: '凝胶'
  },
  {
    value: '其他',
    label: '其他'
  }
]

// 存储方式
export const storages = [{
    value: '冷藏',
    label: '冷藏'
  },
  {
    value: '常温',
    label: '常温'
  },
  {
    value: '干燥',
    label: '干燥'
  },
  {
    value: '密封',
    label: '密封'
  },
  {
    value: '冷冻',
    label: '冷冻'
  },
  {
    value: '避光',
    label: '避光'
  },
  {
    value: '阴凉处',
    label: '阴凉处'
  },
  {
    value: '干燥器',
    label: '干燥器'
  },
  {
    value: '冷冻（-80℃）',
    label: '冷冻（-80℃）'
  },
  {
    value: '其他',
    label: '其他'
  },
]

// 规格型号
export const models = [{
    value: '1ml',
    label: '1ml'
  },
  {
    value: '5ml',
    label: '5ml'
  },
  {
    value: '10ml',
    label: '10ml'
  },
  {
    value: '50ml',
    label: '50ml'
  },
  {
    value: '500ml',
    label: '500ml'
  },
  {
    value: '1L',
    label: '1L'
  },
  {
    value: '1g',
    label: '1g'
  },
  {
    value: '2g',
    label: '2g'
  },
  {
    value: '0.2g',
    label: '0.2g'
  },
  {
    value: '0.1g',
    label: '0.1g'
  },
  {
    value: '0.5g',
    label: '0.5g'
  },
  {
    value: '5g',
    label: '5g'
  },
  {
    value: '10g',
    label: '10g'
  },
  {
    value: '20g',
    label: '20g'
  },
  {
    value: '50g',
    label: '50g'
  },
  {
    value: '其他',
    label: '其他'
  },
  {
    value: '哑铃型试样',
    label: '哑铃型试样'
  },
  {
    value: '长条形试样',
    label: '长条形试样'
  },
  {
    value: '2型试样',
    label: '2型试样'
  },
  {
    value: '棒材',
    label: '棒材'
  },
  {
    value: '圆柱形',
    label: '圆柱形'
  },
  {
    value: '长条',
    label: '长条'
  },
  {
    value: '板材',
    label: '板材'
  },
  {
    value: '直角撕裂试样',
    label: '直角撕裂试样'
  },
  {
    value: '裤型撕裂试样',
    label: '裤型撕裂试样'
  },
]

// 包装
export const packs = [{
    value: '玻璃瓶',
    label: '玻璃瓶'
  },
  {
    value: '塑料瓶',
    label: '塑料瓶'
  },
  {
    value: '塑料袋',
    label: '塑料袋'
  },
  {
    value: '铝板',
    label: '铝板'
  },
  {
    value: '安瓿瓶',
    label: '安瓿瓶'
  },
  {
    value: '自封袋',
    label: '自封袋'
  },
  {
    value: '离心管',
    label: '离心管'
  },
  {
    value: '无菌袋',
    label: '无菌袋'
  },
  {
    value: '锡纸袋',
    label: '锡纸袋'
  },
  {
    value: '气体采样袋',
    label: '气体采样袋'
  },
  {
    value: '牛皮纸袋',
    label: '牛皮纸袋'
  },
  {
    value: '纸袋',
    label: '纸袋'
  },
  {
    value: '纸盒',
    label: '纸盒'
  },
  {
    value: '其他',
    label: '其他'
  }
]

export const trustDeedList = [{
    value: 'BILL_CREATED',
    label: '待审核'
  },
  {
    value: 'BILL_CHECKED',
    label: '待回传'
  },
  {
    value: 'BILL_BACK',
    label: '待接收'
  },
  {
    value: 'BILL_RECEIVE',
    label: '待分派'
  },
  {
    value: 'BILL_ASSIGN',
    label: '执行中'
  },
  {
    value: 'BILL_EXECUTE',
    label: '待交付'
  },
  {
    value: 'BILL_COMPLETED',
    label: '已完成'
  },
  {
    value: 'BILL_CLOSE',
    label: '已关闭'
  }
]
export const units = [
  {
    value: '个',
    label: '个'
  },
  {
    value: '件',
    label: '件'
  },
  {
    value: '瓶',
    label: '瓶'
  },
  {
    value: '袋',
    label: '袋'
  },
  {
    value: '支',
    label: '支'
  },
  {
    value: '罐',
    label:'罐'
  },
  {
    value: '粒',
    label:'粒'
  },
  {
    value: '颗',
    label:'颗'
  },
  {
    value: '克',
    label:'克'
  },
  {
    value: '千克',
    label:'千克'
  },
  {
    value: '毫升',
    label:'毫升'
  },
  {
    value: '升',
    label:'升'
  },
  {
    value: '套',
    label:'套'
  },
  {
    value: '批',
    label:'批'
  }
]